<div class="tag-span">
  <div class="filter-content">
    <div class="tags">
      <div>{{'TAGFILTER.FILTERS' | translate}}:</div>

      @for (tag of tags | async; track tag) {
        <div>
          <tag class="tag" (click)="tagClicked(tag)" [code]="tag.Description | dataTranslate | translate"></tag>
        </div>
      }

      @if (hbox) {
        <tag class="tag" [code]="hbox" (click)="clearHbox()"></tag>
      }
    </div>

    <div class="actions">
      @if (((tagsService.modalIsOpen | async) === false) && ((tags | async)?.length || hbox)) {
        <span class="clear" (click)="onEdit()">{{'TAGFILTER.EDITFILTERS' | translate}}</span>
      }
      @if ((tags | async)?.length || hbox) {
        <span class="clear" (click)="onClear()">{{'TAGFILTER.CLEARFILTERS' | translate}}</span>
      }
    </div>
  </div>
</div>